import { getFullUrl } from 'hubspot-url-utils';
import baseHttpClient from '../../utils/apiClient';
const API_BASE = `${getFullUrl('app-api')}/crm/v3/objects/`;
export const getObject = data => baseHttpClient.get(`${API_BASE}${data.objectType}/${data.objectId}${data.properties ? `?properties=${data.properties.join(',')}` : ''}`);
export function searchObject(data, delay) {
  return baseHttpClient.post(`${API_BASE}${data.objectType}/search`, Object.assign({
    data
  }, delay && {
    delay
  }));
}
export const createObject = ({
  data,
  objectType
}) => baseHttpClient.post(`${API_BASE}${objectType}`, {
  data
});
export const createCrmObjectBatch = ({
  data,
  objectType
}) => baseHttpClient.post(`${API_BASE}${objectType}/batch/create`, {
  data: {
    inputs: data
  }
});